import {
  ApartmentOutlined as ApartmentIcon,
  Code as CodeIcon,
  Description as DescriptionIcon,
  Archive as ArchiveIcon,
  Image as ImageIcon,
  MoreVert as MoreVertIcon,
} from '@mui/icons-material';
import IdeationMenu from '../../common/components/IdeationMenu/IdeationMenu';
import Viewer from 'bpmn-js/lib/Viewer';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import { AiSolutionsIcon } from './AiSolutionIcon';
import { ToolbarIconButton } from './SharedStyle';
import { useDispatch, useSelector } from 'react-redux';
import { updateDiagramData } from '../../slices/diagramViewerSlice';
import { ImportMenuModal } from './ImportMenuModal';
import { ApplyEnterpriseContextModal } from './ApplyEnterpriseContextModalProps';
// import ViewInArIcon from '@mui/icons-material/ViewInAr';
import { fetchTechLandscapeDiagram } from '../../services/llm_api_services';
import { setDiagramPurple } from '../../slices/diagramSlice';
import Modeler from 'bpmn-js/lib/Modeler';
import JSZip from 'jszip';
import { RootState } from '../../store';
import type { AiOpportunity } from '../../slices/SolutionsSlice/AiOpportunitiesInterface';
import type { DiagramData } from './DiagramBpmn';

type DiagramStep = Record<string, unknown>;

interface DiagramContent {
  data?: Record<string, DiagramStep>;
  xml?: string;
  id?: string;
}

interface DiagramMetaData {
  name?: string;
}

export interface DiagramDataProp {
  diagram?: DiagramContent;
  diagramMetaData?: DiagramMetaData;
  [key: string]: unknown;
}

type DiagramGetter = () => unknown;
type ApplyEnterprisesHandler = () => void;

interface BpmnElement {
  id: string;
  type: string;
  [key: string]: unknown;
}

interface ElementRegistry {
  getAll: () => BpmnElement[];
  getGraphics: (element: BpmnElement) => SVGGraphicsElement | null;
}

interface ModelingService {
  setColor: (elements: BpmnElement[], colors: { stroke?: string; fill?: string }) => void;
}

interface DiagramToolbarProps {
  isEnterpriseModalOpen: boolean;
  selectedCard?: Record<string, unknown>;
  showAllAiComponents: boolean;
  onEnterpriseClick: () => void;
  handleAddToSolutionXplr?: () => void;
  onToggleAiSteps: () => void;
  onResetAll: () => void;
  onClose?: () => void;
  onSaveDiagram?: () => void;
  getDiagramData?: DiagramGetter;
  onAddToSolutionXplr?: () => void;
  getDiagramElement?: () => HTMLElement | null;
  onAddToSolutionXPLR: () => void;
  onAiSolutionsClick: () => void;
  onProcessInfoClick?: () => void;
  onDeleteClick?: () => void;
  currentOrg: string;
  aiOpportunityData: AiOpportunity[];
  diagramData: DiagramDataProp | DiagramData | null;
  bpmnInstance?: Modeler | Viewer | undefined | null;
  type?: 'taxonomy' | 'solutionxplr';
  onApplyEnterprises?: ApplyEnterprisesHandler;
  onEdit?: () => void;
  isSaveDisabled?: boolean;
  isProcessDiagram?: boolean;
  // handleIdeationIntake?: () => void;
  onRenameProcess?: () => void;
  onDeleteIdeation?: () => void;
  onDownload?: () => void;
  loadingDocument?: boolean;
  isProcessXPLRActive?: boolean;
}

export const DiagramToolbar: React.FC<DiagramToolbarProps> = ({
  // onAddToSolutionXPLR,
  isEnterpriseModalOpen,
  // showAllAiComponents,
  onEnterpriseClick,
  // onToggleAiSteps,
  isSaveDisabled,
  onAiSolutionsClick,
  onProcessInfoClick = () => {},
  onDeleteClick = () => {},
  currentOrg,
  aiOpportunityData,
  diagramData,
  type = 'solutionxplr',
  bpmnInstance,
  onApplyEnterprises,
  onEdit,
  isProcessDiagram = false,
  // handleIdeationIntake,
  onRenameProcess,
  onDeleteIdeation,
  onDownload,
  loadingDocument = false,
  isProcessXPLRActive = false,
}) => {
  const diagramName =
    (diagramData &&
      'diagramMetaData' in diagramData &&
      (diagramData as DiagramDataProp).diagramMetaData?.name) ||
    'diagram';
  console.log('isSaveDisabled in props', isSaveDisabled);
  const [menuSelected, setMenuSelected] = useState('');
  const [importOpen, setImportOpen] = useState(false);

  const [importTextModalOpen, setImportTextModalOpen] = useState(false);
  const [importXmlModalOpen, setImportXmlModalOpen] = useState(false);
  const [importZipModalOpen, setImportZipModalOpen] = useState(false);
  const [applyEnterpriseContextModalOpen, setApplyEnterpriseContextModalOpen] = useState(false);
  //   const [enterpriseContextCompleted, setEnterpriseContextCompleted] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const mobileMenuRef = useRef<HTMLDivElement>(null); // Add mobile menu ref
  const isEditPermission = useSelector(
    (state: RootState) => state.diagramViewer.diagramData?.isEditPermission
  );

  const submenuTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // const handleClose = () => {
  //   if (onClose) {
  //     dispatch(resetOpportunityDetails());
  //     onClose();
  //     return;
  //   }
  //   dispatch(closeDiagram());
  //   navigate('/', { state: { activeStep: 'process-flow' } });
  // };

  // const handleApplyEnterpriseContextClick = () => {
  //     setApplyEnterpriseContextModalOpen(true);
  // };

  // const closeDropdown = () => {
  //     setMenuSelected('');
  //     setHoveredSubmenu('');
  // };

  // const handleExportToZip = async () => {
  //   if (!bpmnInstance || typeof bpmnInstance.saveXML !== 'function') {

  //     return;
  //   }

  //   try {

  //     const selectedSolutionKey = 'task_1';

  //     const rawData = diagramData?.diagram?.data || {};
  //     const selectedData = rawData[selectedSolutionKey];

  //     if (!selectedData) {
  //       console.warn(`No data found for selected solution: ${selectedSolutionKey}`);
  //       return;
  //     }

  //     const businessData = {
  //       [selectedSolutionKey]: {
  //         name: selectedData.name,
  //         type: selectedData.type,
  //         description: selectedData.description,
  //         data_landscape_item_name: selectedData.data_landscape_item_name,
  //         data_landscape_tech_vendor: selectedData.data_landscape_tech_vendor,
  //       }
  //     };

  //     const combinedExport = {

  //       'data.json': businessData
  //     };

  //     const blob = new Blob([JSON.stringify(combinedExport, null, 2)], {
  //       type: 'application/json'
  //     });

  //     const url = URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = `${selectedSolutionKey}-export.json`;
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //     URL.revokeObjectURL(url);

  //     console.log(`Exported JSON for ${selectedSolutionKey}`);
  //     closeDropdown();
  //   } catch (err) {
  //     console.error('Export failed:', err);
  //   }
  // };

  const handleExportToXml = async () => {
    if (!bpmnInstance || typeof bpmnInstance.saveXML !== 'function') {
      console.warn('No valid BPMN instance available.');
      return;
    }

    try {
      const { xml } = await bpmnInstance.saveXML({ format: true });

      if (!xml) {
        console.warn('XML export failed: No XML content generated.');
        return;
      }

      // Use diagram name or fallback to 'diagram'
      const fileName = `${diagramName}.xml`;

      const xmlBlob = new Blob([xml], { type: 'text/xml' });
      const url = URL.createObjectURL(xmlBlob);

      const a = document.createElement('a');
      a.download = fileName;
      a.href = url;
      a.style.display = 'none';
      a.onclick = function (event) {
        document.body.removeChild(event.target as Node);
      };

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      console.log(`Exported XML as ${fileName}`);
    } catch (err) {
      console.error('Failed to export XML:', err);
    }
  };

  const handleExportToSvg = async () => {
    if (!bpmnInstance || typeof bpmnInstance.saveSVG !== 'function') {
      return;
    }

    try {
      const { svg } = await bpmnInstance.saveSVG();

      if (!svg) {
        console.warn('SVG export failed: No SVG content generated.');
        return;
      }

      const fileName = `${diagramName}.svg`;

      const svgBlob = new Blob([svg], { type: 'image/svg+xml' });
      const url = URL.createObjectURL(svgBlob);

      const a = document.createElement('a');
      a.download = fileName;
      a.href = url;
      a.style.display = 'none';
      a.onclick = function (event) {
        document.body.removeChild(event.target as Node);
      };

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      console.log(`Exported SVG as ${fileName}`);
    } catch (err) {
      console.error('Failed to export SVG:', err);
    }
  };

  const handleExportToPng = async () => {
    if (!bpmnInstance || typeof bpmnInstance.saveSVG !== 'function') {
      return;
    }

    try {
      const { svg } = await bpmnInstance.saveSVG();

      if (!svg) {
        console.warn('PNG export failed: No SVG content generated.');
        return;
      }

      const fileName = `${diagramName}.png`;

      const domUrl = window.URL || window.webkitURL || window;
      const margin = 0;
      const fill = '#ffffff';

      const heightMatch = svg.match(/height="(\d+)/m);
      const widthMatch = svg.match(/width="(\d+)/m);
      const height = heightMatch ? parseInt(heightMatch[1], 10) : 200;
      const width = widthMatch ? parseInt(widthMatch[1], 10) : 200;

      const namespacedSvg = svg.match(/xmlns="/im)
        ? svg
        : svg.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ');

      let canvas = document.createElement('canvas');
      canvas.width = width + margin * 2;
      canvas.height = height + margin * 2;
      const ctx = canvas.getContext('2d');

      const svgBlob = new Blob([namespacedSvg], {
        type: 'image/svg+xml;charset=utf-8',
      });

      const url = domUrl.createObjectURL(svgBlob);
      const img = new Image();

      img.onload = () => {
        if (ctx) {
          ctx.drawImage(img, margin, margin);

          if (fill) {
            const styledCanvas = document.createElement('canvas');
            styledCanvas.width = canvas.width;
            styledCanvas.height = canvas.height;
            const styledCtx = styledCanvas.getContext('2d');

            if (styledCtx) {
              styledCtx.save();
              styledCtx.fillStyle = fill;
              styledCtx.fillRect(0, 0, canvas.width, canvas.height);
              styledCtx.restore();
              styledCtx.drawImage(canvas, 0, 0);
              canvas = styledCanvas;
            }
          }

          domUrl.revokeObjectURL(url);

          const downloadLink = document.createElement('a');
          downloadLink.download = fileName;
          downloadLink.href = canvas.toDataURL();
          downloadLink.style.visibility = 'hidden';
          downloadLink.onclick = function (event) {
            document.body.removeChild(event.target as Node);
          };

          document.body.appendChild(downloadLink);
          downloadLink.click();
        }
      };

      img.src = url;
    } catch (err) {
      console.error('Failed to export PNG:', err);
    }
  };

  // --- End Export Functions ---
  const menuItemStyle = {
    p: 1,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    fontSize: '16px',
    fontWeigtht: 500,
    color: '#000000',
    FontFamily: 'Poppins',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#f0f8ff',
      color: '#1A55F9',
    },
    //   borderBottom: '1px solid #f0f0f0',
  };

  // Import handlers
  const handleImportTextClick = () => {
    console.log('Import from text clicked');
    setImportTextModalOpen(true);
    setMenuSelected('');
    // setHoveredSubmenu('');
    setMobileMenuOpen(false);
  };

  const handleImportXmlClick = () => {
    console.log('Import from XML clicked');
    setImportXmlModalOpen(true);
    setMenuSelected('');
    setMobileMenuOpen(false);
  };

  const handleImportZipClick = () => {
    console.log('Import from Zip clicked');
    setImportZipModalOpen(true);
    setMenuSelected('');
    // setHoveredSubmenu('');
    setMobileMenuOpen(false);
  };

  const handleMobileMenuItemClick = (action: () => void) => {
    action();
    setMobileMenuOpen(false);
  };
  //  const handleMouseEnterSubmenu = (submenuType: string) => {
  //     if (submenuTimeoutRef.current) {
  //         clearTimeout(submenuTimeoutRef.current);
  //     }
  //     setHoveredSubmenu(submenuType);
  // };

  // const handleMouseLeaveSubmenu = () => {
  //     submenuTimeoutRef.current = setTimeout(() => {
  //         setHoveredSubmenu('');
  //     }, 150);
  // };

  // const handleMouseEnterSubmenuCard = () => {
  //     if (submenuTimeoutRef.current) {
  //         clearTimeout(submenuTimeoutRef.current);
  //     }
  // };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuSelected('');
        //  setHoveredSubmenu('');
      }
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target as Node)) {
        setMobileMenuOpen(false);
      }
    };

    if (menuSelected || mobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    const timeoutAtMount = submenuTimeoutRef.current;
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      if (timeoutAtMount) {
        clearTimeout(timeoutAtMount);
      }
    };
  }, [menuSelected, mobileMenuOpen]);

  const subMenuOptions = {
    Import: [
      { label: 'From text', icon: <CodeIcon />, onClick: handleImportTextClick },
      { label: 'From XML', icon: <DescriptionIcon />, onClick: handleImportXmlClick },
      { label: 'From Zip', icon: <ArchiveIcon />, onClick: handleImportZipClick },
    ],
    Export: [
      // { label: 'To Zip', icon: <ArchiveIcon />, onClick: handleExportToZip },  //Hiding to Zip Option from BPMN
      { label: 'To XML', icon: <CodeIcon />, onClick: handleExportToXml },
      { label: 'To SVG', icon: <CodeIcon />, onClick: handleExportToSvg },
      { label: 'To PNG', icon: <ImageIcon />, onClick: handleExportToPng },
    ],
  };
  const handleImportSubmit = (type: 'text' | 'xml' | 'zip') => (data: string | File) => {
    // xml import: ensure the imported XML updates diagramData.diagram.xml and preserves other diagramData fields
    const updateXml = (xmlString: string) => {
      if (!diagramData || !diagramData.diagram) return;
      dispatch(
        updateDiagramData({
          DiagramData: {
            ...diagramData,
            diagram: {
              ...diagramData.diagram,
              xml: xmlString,
            },
          },
        })
      );
    };
    if (type === 'text' && typeof data === 'string') {
      updateXml(data);
    } else if (type === 'xml' && data instanceof File) {
      const reader = new FileReader();
      reader.onload = function (e) {
        const result = e.target?.result;
        if (typeof result === 'string') {
          updateXml(result);
        }
      };
      reader.readAsText(data);
    } else if (type === 'zip' && data instanceof File) {
      // Extract BPMN/XML from ZIP
      const reader = new FileReader();
      reader.onload = async function (e) {
        const zipBuffer = e.target?.result;
        if (zipBuffer instanceof ArrayBuffer) {
          try {
            const zip = await JSZip.loadAsync(zipBuffer);
            let foundXml: import('jszip').JSZipObject | undefined;

            zip.forEach((relativePath: string, zipEntry) => {
              if (relativePath.endsWith('.bpmn') || relativePath.endsWith('.xml')) {
                foundXml = zipEntry;
              }
            });
            if (foundXml) {
              const xmlString = await foundXml.async('text');
              updateXml(xmlString);
            } else {
              console.warn('ZIP file did not contain a .bpmn or .xml file.');
            }
          } catch (error) {
            console.error('Failed to extract BPMN from ZIP: ' + error);
          }
        }
      };
      reader.readAsArrayBuffer(data);
    }
  };

  const handleSetDiagramColor = () => {
    const colorMap: Record<string, [string, string]> = {
      'bpmn:Task': ['#7c3aed', '#7c3aed'],
      'bpmn:UserTask': ['#7c3aed', '#7c3aed'],
      'bpmn:ServiceTask': ['#7c3aed', '#7c3aed'],
      'bpmn:SendTask': ['#7c3aed', '#7c3aed'],
      'bpmn:ReceiveTask': ['#7c3aed', '#7c3aed'],
      'bpmn:ManualTask': ['#7c3aed', '#7c3aed'],
      'bpmn:BusinessRuleTask': ['#7c3aed', '#7c3aed'],
      'bpmn:ScriptTask': ['#7c3aed', '#7c3aed'],
      'bpmn:Activity': ['#7c3aed', '#7c3aed'],
      'bpmn:SubProcess': ['#7c3aed', '#7c3aed'],
    };

    // Check if bpmnInstance exists and has the get method
    if (!bpmnInstance || typeof bpmnInstance.get !== 'function') {
      return;
    }

    const isModeler = bpmnInstance instanceof Modeler;

    try {
      const elementRegistry = bpmnInstance.get('elementRegistry') as ElementRegistry | undefined;

      if (!elementRegistry) {
        return;
      }

      if (isModeler) {
        // For Modeler instances, use the modeling service
        const modeling = bpmnInstance.get('modeling') as ModelingService | undefined;

        if (!modeling || typeof modeling.setColor !== 'function') {
          return;
        }

        Object.entries(colorMap).forEach(([type, [stroke, fill]]) => {
          const elements = elementRegistry.getAll().filter((el: BpmnElement) => el.type === type);
          if (elements.length > 0) {
            try {
              modeling.setColor(elements, { stroke, fill });
            } catch (error) {
              console.error(`Failed to set color for elements of type ${type}:`, error);
            }
          }
        });
      } else {
        // For Viewer instances, manipulate SVG elements directly
        Object.entries(colorMap).forEach(([type, [stroke, fill]]) => {
          const elements = elementRegistry.getAll().filter((el: BpmnElement) => el.type === type);
          if (elements.length > 0) {
            elements.forEach((element: BpmnElement) => {
              try {
                const gfx = elementRegistry.getGraphics(element);
                if (gfx) {
                  // Find the main shape elements but exclude text elements
                  const shapeElements = gfx.querySelectorAll<SVGGraphicsElement>(
                    'rect, path, circle, ellipse'
                  );
                  shapeElements.forEach((shapeEl) => {
                    // Check if this is not a text-related element
                    const parentGroup = shapeEl.closest('g');
                    const isTextElement =
                      parentGroup &&
                      (parentGroup.classList.contains('djs-label') ||
                        parentGroup.querySelector('text') === shapeEl ||
                        shapeEl.tagName === 'text');

                    if (!isTextElement) {
                      // Set stroke and fill colors only for non-text elements
                      if (stroke) {
                        shapeEl.style.stroke = stroke;
                        shapeEl.setAttribute('stroke', stroke);
                      }
                      if (fill) {
                        shapeEl.style.fill = fill;
                        shapeEl.setAttribute('fill', fill);
                        if (shapeEl && shapeEl?.classList.contains('djs-hit')) {
                          shapeEl.style.display = 'none';
                          shapeEl.style.zIndex = 'none';
                        }
                      }

                      shapeEl.style.pointerEvents = 'auto';
                    }
                  });

                  const textElements = gfx.querySelectorAll<SVGGraphicsElement>('text, tspan');
                  textElements.forEach((textEl) => {
                    textEl.style.fill = '#ffffff';
                    textEl.setAttribute('fill', '#ffffff');
                    textEl.style.fontSize = textEl.style.fontSize || '12px';
                    textEl.style.fontFamily = textEl.style.fontFamily || 'Arial, sans-serif';
                  });
                }
              } catch (error) {
                console.error(`Failed to set color for element ${element.id}:`, error);
              }
            });
          }
        });
      }
    } catch (error) {
      console.error('Error accessing BPMN services:', error);
    }
  };

  const handleFetchTechLandscapeDiagram = async () => {
    try {
      const opportunitiesToSave = Array.isArray(window._aiOpportunityData)
        ? [...window._aiOpportunityData]
        : [...aiOpportunityData];

      const stepDescriptions = diagramData?.diagram?.data ?? {};

      const payload = {
        organization_id: currentOrg,
        diagram_xml: diagramData?.diagram?.xml ?? '',
        step_descriptions: stepDescriptions,
        ai_opportunities: opportunitiesToSave.map((opp: AiOpportunity) => ({
          ...opp,
          diagram_id: diagramData?.diagram?.id,
        })),
      };

      setApplyEnterpriseContextModalOpen(false);
      const solutionXPLRData = (await fetchTechLandscapeDiagram(payload)) as {
        xml?: string;
        step_descriptions?: Record<string, DiagramStep>;
        ai_opportunities?: AiOpportunity[];
      };
      const { xml, step_descriptions, ai_opportunities } = solutionXPLRData;
      if (xml) {
        await bpmnInstance?.importXML(xml);
        dispatch(
          updateDiagramData({
            DiagramData: {
              ...(diagramData ?? {}),
              diagram: {
                ...(diagramData?.diagram ?? {}),
                data: step_descriptions ?? diagramData?.diagram?.data,
                xml: xml,
              },
            },
            aiOpportunityData: [...(ai_opportunities ?? [])],
          })
        );
      }
      // setEnterpriseContextCompleted(true);

      dispatch(setDiagramPurple(true));

      handleSetDiagramColor();

      if (onApplyEnterprises) {
        setTimeout(() => {
          onApplyEnterprises?.();
        });
      }
    } catch (error) {
      console.error('Error generating AI solutions:', error);
      setApplyEnterpriseContextModalOpen(false);
    }
  };
  //  const handleSendToSolutionXplr = useCallback(() => {
  //     handleClose();
  //     if (selectedCard?.id) {
  //         navigate(`/solution-xplr?subprocessId=${selectedCard.id}`);
  //     } else {
  //         console.warn('Selected card is undefined. Navigating without subprocessId.');
  //         navigate('/solution-xplr');
  //     }
  // }, [navigate, selectedCard?.id, handleClose]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-end', sm: 'center' },
          justifyContent: 'flex-end',
          width: '100%',
          gap: { xs: 1, sm: 2 },
          px: { xs: isProcessXPLRActive ? 0 : 1, sm: isProcessXPLRActive ? 0 : 2 },
          // py: 1,
        }}
      >
        {/* Icon Buttons Group */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 0.5, sm: 1 },
            flexWrap: 'nowrap',
            justifyContent: { xs: 'flex-start', sm: 'flex-start' },
            width: { xs: '100%', sm: 'auto' },
            backgroundColor: isProcessDiagram ? 'transparent' : 'white',
          }}
        >
          {/* {type === 'taxonomy' && (
                    <ToolbarIconButton
                        icon={<OpenInNewIcon />}
                        tooltip="Add to Solution XPLR"
                        onClick={onAddToSolutionXPLR}
                    />
                )} */}

          {/* {type === 'taxonomy' && (
                    <ToolbarIconButton
                        icon={isLoading ? <CircularProgress size={18} sx={{ color: 'inherit' }} /> : <ViewInArIcon />}
                        tooltip="Apply Enterprise Context"
                        onClick={isLoading ? () => { } : handleApplyEnterpriseContextClick}
                    />
                )} */}
          {!isMobile && (
            <>
              <ApplyEnterpriseContextModal
                open={applyEnterpriseContextModalOpen}
                onClose={() => setApplyEnterpriseContextModalOpen(false)}
                handleConfirm={handleFetchTechLandscapeDiagram}
                type="taxonomy"
                title="Apply Enterprise Context"
                message="This action will apply enterprise context to generate a technology landscape diagram. Do you want to continue?"
              />
              {/* {type === 'taxonomy'  && isEditPermission &&
                    <ToolbarIconButton
                        icon={<img src={'/images/info-new.svg'} alt='Process Information' height={'16px'} width={'16px'}/>}
                        tooltip="Process Information"
                        onClick={onProcessInfoClick}
                    />
                } */}

              {type === 'taxonomy' && !isEditPermission && (
                <ToolbarIconButton
                  icon={<AiSolutionsIcon />}
                  tooltip="AI Solutions Library"
                  onClick={onAiSolutionsClick}
                />
              )}

              {!isEditPermission && !isProcessDiagram && (
                <ToolbarIconButton
                  icon={<ApartmentIcon />}
                  tooltip="Enterprise Context"
                  onClick={onEnterpriseClick}
                  active={isEnterpriseModalOpen}
                />
              )}
              {isProcessDiagram && (
                <>
                  {/* <Button
                  onClick={handleIdeationIntake}
                  sx={{
                    border: '1px solid #1A55F9',
                    backgroundColor: '#FFFFFF',
                    color: '#1A55F9',
                    fontFamily: 'Poppins',
                    fontWeight: 500,
                    fontSize: '13px',
                    lineHeight: '100%',
                    textAlign: 'center',
                    textTransform: 'none',
                    borderRadius: '4px',
                    px: 1,
                    '&:hover': {
                      backgroundColor: '#E8EDFF',
                      borderColor: '#0f3fd1',
                    },
                  }}
                >
                  Ideation Intake
                </Button> */}
                  <IdeationMenu
                    onEdit={onRenameProcess}
                    onDelete={onDeleteIdeation}
                    editLabel="Rename Process"
                    deleteLabel="Delete Ideation"
                    onDownload={onDownload}
                    disableDownload={loadingDocument}
                  />
                </>
              )}

              {/* <ToolbarIconButton
                    icon={showAllAiComponents ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    tooltip={`${showAllAiComponents ? 'Hide' : 'Show'} AI Components`}
                    onClick={onToggleAiSteps}
                    active={showAllAiComponents}
                /> */}
              {/* <Box
                    ref={menuRef}
                    sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}
                >
                    <ToolbarIconButton
                        icon={<MenuIcon />}
                        tooltip="Menu"
                        onClick={() => setMenuSelected(menuSelected === 'menu' ? '' : 'menu')}
                        active={menuSelected === 'menu'}
                    />

                    {menuSelected === 'menu' && (
                        <Box sx={{
                            position: 'absolute',
                            top: '100%',
                            right: 0,
                            zIndex: 1000,
                            mt: 1,
                            minWidth: 150,
                            backgroundColor: 'white',
                            boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
                            borderRadius: '12px',
                            border: '1px solid #e0e0e0',
                            overflow: 'visible'
                        }}>
                            {/* Import Menu Item */}
              {/* <Box
                                sx={{
                                    cursor: 'pointer',
                                    p: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    position: 'relative',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: '#f8f9fa',
                                        color: '#1A55F9'
                                    },
                                    borderBottom: '1px solid #f0f0f0'
                                }}
                                onMouseEnter={() => handleMouseEnterSubmenu('Import')}
                                onMouseLeave={handleMouseLeaveSubmenu}
                            >
                                <ImportIcon sx={{ fontSize: '18px', color: '#666' }} />
                                Import
                                <Box sx={{ ml: 'auto', fontSize: '12px', color: '#666' }}>▶</Box>

                                {/* Import Submenu */}
              {/* {hoveredSubmenu === 'Import' && (
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            right: '100%',
                                            top: 0,
                                            minWidth: 180,
                                            backgroundColor: 'white',
                                            boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
                                            borderRadius: '12px',
                                            border: '1px solid #e0e0e0',
                                            ml: 0.5,
                                            zIndex: 1001,
                                            overflow: 'hidden'
                                        }}
                                        onMouseEnter={handleMouseEnterSubmenuCard}
                                        onMouseLeave={handleMouseLeaveSubmenu}
                                    >
                                        {subMenuOptions.Import.map((option, index) => (
                                            <Box
                                                key={option.label}
                                                onClick={option.onClick}
                                                sx={{
                                                    p: 2,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1.5,
                                                    fontSize: '14px',
                                                    transition: 'all 0.2s ease',
                                                    '&:hover': {
                                                        backgroundColor: '#f0f8ff',
                                                        color: '#1A55F9'
                                                    },
                                                    ...(index < subMenuOptions.Import.length - 1 && {
                                                        borderBottom: '1px solid #f0f0f0'
                                                    })
                                                }}
                                            >
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    fontSize: '16px',
                                                    color: '#666'
                                                }}>
                                                    {option.icon}
                                                </Box>
                                                {option.label}
                                            </Box>
                                        ))}
                                    </Box> */}
              {/* )}
                            </Box> */}

              {/* Export Menu Item */}
              {/* <Box
                                sx={{
                                    cursor: 'pointer',
                                    p: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    position: 'relative',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: '#f8f9fa',
                                        color: '#1A55F9'
                                    }
                                }}
                                onMouseEnter={() => handleMouseEnterSubmenu('Export')}
                                onMouseLeave={handleMouseLeaveSubmenu}
                            >
                                <ImportIcon sx={{ fontSize: '18px', color: '#666' }} />
                                Export
                                <Box sx={{ ml: 'auto', fontSize: '12px', color: '#666' }}>▶</Box>

                                {hoveredSubmenu === 'Export' && (
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            right: '100%',
                                            top: 0,
                                            minWidth: 180,
                                            backgroundColor: 'white',
                                            boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
                                            borderRadius: '12px',
                                            border: '1px solid #e0e0e0',
                                            ml: 0.5,
                                            zIndex: 1001,
                                            overflow: 'hidden'
                                        }}
                                        onMouseEnter={handleMouseEnterSubmenuCard}
                                        onMouseLeave={handleMouseLeaveSubmenu}
                                    >
                                        {subMenuOptions.Export.map((option, index) => (
                                            <Box
                                                key={option.label}
                                                onClick={option.onClick}
                                                sx={{
                                                    p: 2,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1.5,
                                                    fontSize: '14px',
                                                    transition: 'all 0.2s ease',
                                                    '&:hover': {
                                                        backgroundColor: '#f0f8ff',
                                                        color: '#1A55F9'
                                                    },
                                                    ...(index < subMenuOptions.Export.length - 1 && {
                                                        borderBottom: '1px solid #f0f0f0'
                                                    })
                                                }}
                                            >
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    fontSize: '16px',
                                                    color: '#666'
                                                }}>
                                                    {option.icon}
                                                </Box>
                                                {option.label}
                                            </Box>
                                        ))}
                                    </Box>
                                )}
                            </Box> */}
              {/* </Box>
                            )}
                 </Box> */}

              {type === 'taxonomy' && isEditPermission && (
                <Box
                  ref={menuRef}
                  sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}
                >
                  <ToolbarIconButton
                    icon={<MoreVertIcon />}
                    tooltip="More options"
                    onClick={() => setMenuSelected(menuSelected === 'more' ? '' : 'more')}
                    active={menuSelected === 'more'}
                    sx={{
                      // Add these styles to fix hover when menu is open
                      ...(menuSelected === 'more' && {
                        '&:hover': {
                          backgroundColor: '#2962FF !important',
                          color: 'white !important',
                          '& svg': {
                            color: 'white !important',
                          },
                        },
                      }),
                    }}
                  />

                  {menuSelected === 'more' && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '100%',
                        right: 0,
                        zIndex: 1000,
                        mt: 1,
                        minWidth: 180,
                        backgroundColor: 'white',
                        boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
                        borderRadius: '12px',
                        border: '1px solid #e0e0e0',
                        overflow: 'hidden',
                        fontFamily: 'Poppins',
                      }}
                    >
                      <Box onClick={onDeleteClick} sx={menuItemStyle}>
                        <img
                          src={'/images/delete-new.svg'}
                          alt="delete process"
                          height={'16px'}
                          width={'16px'}
                        />
                        Delete Process
                      </Box>
                    </Box>
                  )}
                </Box>
              )}
            </>
          )}
        </Box>

        {isMobile && (
          <Box
            ref={mobileMenuRef}
            sx={{
              position: 'relative',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '9px',
              justifyContent: 'flex-end',
            }}
          >
            <ToolbarIconButton
              icon={<img src="/images/More_icon.svg" alt="more" />}
              tooltip="More options"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              active={mobileMenuOpen}
              sx={{
                p: '4px',
                backgroundColor: 'white',
                minWidth: '35px',
                height: '35px',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
            />
            {/* // {enterpriseContextCompleted ? (
                    //     <ActionButton
                    //         label="Send to Solution XPLR"
                    //         onClick={handleSendToSolutionXplr}
                    //         sx={{
                    //             backgroundColor: '#1A55F9',
                    //             color: 'white',
                    //             minWidth: '64px',
                    //             px: 1.5,
                    //             py: 0.5,
                    //             '&:hover': { backgroundColor: '#0641e6' },
                    //         }}
                    //     />
                    // ) : (
                    //     <ActionButton
                    //         label="Save"
                    //         onClick={onSaveDiagram || (() => dispatch(closeDiagram()))}
                    //         sx={{
                    //             backgroundColor: 'white',
                    //             minWidth: '64px',
                    //             px: 1.5,
                    //             py: 0.5,
                    //             '&:hover': { backgroundColor: 'primary.main' },
                    //         }}
                    //     />
                    // )} */}
            {mobileMenuOpen && (
              <Box
                sx={{
                  position: { xs: 'fixed', md: 'absolute' },
                  top: { xs: '130px', md: '100%' },
                  right: { xs: 16, md: 0 },
                  zIndex: 6000,
                  mt: { xs: 0, md: 1 },
                  minWidth: 220,
                  backgroundColor: 'white',
                  boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
                  borderRadius: '12px',
                  border: '1px solid #e0e0e0',
                  overflow: 'hidden',
                }}
              >
                {/* AI Solutions */}
                {type === 'taxonomy' && isEditPermission && (
                  <Box
                    onClick={() => handleMobileMenuItemClick(onProcessInfoClick)}
                    sx={menuItemStyle}
                  >
                    Process Information
                  </Box>
                )}

                {/* AI Solutions */}
                {type === 'taxonomy' && (
                  <Box
                    onClick={() => handleMobileMenuItemClick(onAiSolutionsClick)}
                    sx={menuItemStyle}
                  >
                    AI Solutions Library
                  </Box>
                )}

                {/* Enterprise Context */}
                <Box
                  onClick={() => handleMobileMenuItemClick(onEnterpriseClick)}
                  sx={{
                    ...menuItemStyle,
                    backgroundColor: isEnterpriseModalOpen ? '#f0f8ff' : 'transparent',
                  }}
                >
                  Enterprise Context
                </Box>

                {onEdit && (
                  <Box onClick={() => handleMobileMenuItemClick(onEdit)} sx={menuItemStyle}>
                    Edit Name
                  </Box>
                )}

                {/* Import (collapsible) */}
                <Box
                  onClick={() => setImportOpen((prev) => !prev)}
                  sx={{
                    ...menuItemStyle,
                    justifyContent: 'space-between',
                  }}
                >
                  {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>

                                    Import
                                </Box> */}
                </Box>

                {importOpen && (
                  <Box sx={{ pl: 4 }}>
                    {subMenuOptions.Import.map((option) => (
                      <Box
                        key={option.label}
                        onClick={() => handleMobileMenuItemClick(option.onClick)}
                        sx={menuItemStyle}
                      >
                        {option.icon}
                        {option.label}
                      </Box>
                    ))}
                  </Box>
                )}

                {type === 'taxonomy' && isEditPermission && (
                  <Box onClick={() => handleMobileMenuItemClick(onDeleteClick)} sx={menuItemStyle}>
                    Delete Process
                  </Box>
                )}

                {/* {type === 'taxonomy' && (
                                <Box
                                    onClick={() => handleMobileMenuItemClick(onDeleteClick)}
                                    sx={menuItemStyle}
                                >

                                    Delete Process
                                </Box>
                            )} */}
              </Box>
            )}
          </Box>
        )}

        {/* {!isMobile && (
                <ActionButton
                    label="Save"
                    onClick={onSaveDiagram || (() => dispatch(closeDiagram()))}
                    sx={{
                        backgroundColor: 'white',
                        '&:hover': { backgroundColor: 'primary.main' },
                    }}
                />
            )} */}

        {/* {isEditPermission && (
  <Tooltip
    title={
      isSaveDisabled
        ? "This will be enabled after updating BPMN"
        : ""
    }
    arrow
    placement="top"
  >
    <span>
      <ActionButton
                    label="Save"
                    disabled={isSaveDisabled}
                    onClick={onSaveDiagram || (() => dispatch(closeDiagram()))}
                    sx={{
                     backgroundColor: isSaveDisabled ? '#E0E0E0' : 'white',
                      color: isSaveDisabled ? '#9E9E9E' : 'inherit',
                      cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
                      '&:hover': {
                        backgroundColor: isSaveDisabled ? '#E0E0E0' : 'primary.main'
                      },
                      opacity: isSaveDisabled ? 0.6 : 1,
                    }}
                  />
                </span>
              </Tooltip>
            )} */}

        {/* Close Button */}
        {/* {!isMobile && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
        </Box>
      )} */}

        {/* Import Modals */}
        <ImportMenuModal
          open={importTextModalOpen}
          onClose={() => setImportTextModalOpen(false)}
          type="text"
          onSubmit={handleImportSubmit('text')}
        />

        <ImportMenuModal
          open={importXmlModalOpen}
          onClose={() => setImportXmlModalOpen(false)}
          type="xml"
          onSubmit={handleImportSubmit('xml')}
        />
        <ImportMenuModal
          open={importZipModalOpen}
          onClose={() => setImportZipModalOpen(false)}
          type="zip"
          onSubmit={handleImportSubmit('zip')}
        />
      </Box>
    </>
  );
};
